module.exports = __webpack_public_path__ + "img/23.bef64022.jpg";